<template>
    <div>
        <h3 id="top-feuillet">{{$t("Bareme.etape1.titre")}}</h3>
        <div>
          <p v-html="$t('Bareme.etape1.aide', {url: 'https://www.ge.ch/publication?organisation=51&type=182&titre=Aide%20au%20remplissage%20de%20la%20d%C3%A9claration%20pour%20le%20pr%C3%A9l%C3%A8vement%20de%20l%27imp%C3%B4t%20%C3%A0%20la%20source'})"></p>
      </div>
    </div>
</template>

<script>
export default {
  name: 'section-info',
};
</script>

<style scoped>

</style>
